"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutMissingFieldType = void 0;
var CheckoutMissingFieldType;
(function (CheckoutMissingFieldType) {
    CheckoutMissingFieldType["BILLING"] = "Billing";
    CheckoutMissingFieldType["DELIVERY"] = "Delivery";
})(CheckoutMissingFieldType || (exports.CheckoutMissingFieldType = CheckoutMissingFieldType = {}));
//# sourceMappingURL=EventCheckoutMissingFieldType.js.map